import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import CircularProgress from "@mui/material/CircularProgress";

import { checkHomeAffiliate, fetchAffiliateInfo } from "../api/getClassesApi";
import UserNotificationDisplay from '../components/UserNotificationDisplay';
import WeeklyStreakNotification from '../components/WeeklyStreakNotification';

const TrainingDiaryPage = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [showNotifications, setShowNotifications] = useState(false);
    const [showWeeklyStreak, setShowWeeklyStreak] = useState(false);
    const [affiliateData, setAffiliateData] = useState(null);
    const [preferredNotificationId, setPreferredNotificationId] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const paramValue = params.get("notificationId");
        const parsed = Number(paramValue);
        setPreferredNotificationId(Number.isFinite(parsed) ? parsed : null);
    }, [location.search]);

    useEffect(() => {
        const getUserHomeGym = async () => {
            try {
                const homeAffiliateData = await checkHomeAffiliate();
                if (homeAffiliateData?.homeAffiliate) {
                    const affiliateInfo = await fetchAffiliateInfo(homeAffiliateData.homeAffiliate);
                    setAffiliateData(affiliateInfo);
                    setShowWeeklyStreak(true); // Show weekly streak first
                    setIsLoading(false);
                } else {
                    navigate("/register-training");
                    setIsLoading(false);
                }
            } catch (error) {
                console.error("❌ Error fetching user home gym:", error);
                navigate("/register-training");
                setIsLoading(false);
            }
        };

        getUserHomeGym();
    }, [navigate]);

    const handleWeeklyStreakSeen = () => {
        setShowWeeklyStreak(false);
        setShowNotifications(true); // Show notifications after weekly streak
    };

    const handleAllNotificationsSeen = () => {
        setShowNotifications(false);
        // Navigate to classes page after notifications are seen
        if (affiliateData) {
            navigate("/classes", { state: { affiliate: affiliateData.affiliate } });
        }
    };

    return (
        <Container maxWidth={false} sx={{ mt: 4 }}>
            {isLoading && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.7)',
                        zIndex: 999
                    }}
                >
                    <CircularProgress size={60} />
                </Box>
            )}

            {showWeeklyStreak && (
                <WeeklyStreakNotification
                    onNotificationSeen={handleWeeklyStreakSeen}
                />
            )}

            {showNotifications && (
                <UserNotificationDisplay
                    preferredNotificationId={preferredNotificationId}
                    onAllNotificationsSeen={handleAllNotificationsSeen}
                />
            )}
        </Container>
    );
};

export default TrainingDiaryPage;